<div style="display: flex; flex-direction: column">
    <div style="flex-basis: 50%">
        <app-tiktok-orders></app-tiktok-orders>
    </div>
</div>
